import React, { useState, useEffect, useRef } from 'react';
import Table from '../Common/table';
import axios from '../httpServices/httpService';
import api from '../config.json'
import swal from 'sweetalert';
import auth from '../httpServices/authService';
import validation from '../utill/validation';
import _, { cloneDeep, result } from 'lodash';
import joi, { object } from 'joi'
import Loading from '../utill/LoadingComponent';
import date from '../utill/dateTime';
// import EquipmentSelection from '../Common/equipmentSelection';
import { ToastContainer, toast } from 'react-toastify';
import DateSelection from '../Common/DateSelection';
import { Button, Checkbox, Modal, Select } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faFilePdf, faMinusCircle, faPlusCircle, faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/vg.png';
import ExportPdfButton from '../utill/ExportPdf';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import ProcessProductPatrolInspection from '../pdfFormat/ProcessProductPatrolInspection';
import PokaYokeSheet from '../pdfFormat/PokayokeMonitoringSheet';
import DailyInitialFlowManagement from '../pdfFormat/DailyInitialFlowManagement';
import DataEntryReportView from '../pdfFormat/DataEntryReportView';
import Tooltip from '../utill/tooltip';
import DailyInitialFlowManagement_PROCESS from '../pdfFormat/DailyIMFFaridabad_Process_Parameter';
import PaginationComponent from '../Common/PaginationComponent';
import SPCLineChart from '../Charts/SPCLineChart';


const SPCReport = ({ handleDownloadTableToExcel, equips, equipGroups, fromDateLimit, Heading }) => {
    const reportType = [
        // { label: "Incoming Inspection", value: "Incoming", name: "IncomingInspection" },
        // { label: "First Part Inspection", value: "FirstPart", name: "FirstPartInspection" },
        // { label: "Inprocess Inspection", value: "Inprocess", name: "InProcessInspection" },
        // { label: "Last Part Inspection ", value: "LastPart", name: "LastPartInspection" },
        // { label: "FinishedGoods Inspection", value: "FinishedGoods", name: 'FG_Inspection' }
    ]
    const [qualityData, setQualityData] = useState([])
    const [inputData, setInputData] = useState({ From: new Date(), Till: new Date() });
    const [parts, setAllParts] = useState([]);
    const [types, setAllTypes] = useState([]);
    const [allTypeCache, setAllTypeCache] = useState([]);
    const [querySuccess, setQuerySuccess] = useState(false);
    const [sortColumn, setSortColumn] = useState({ path: 'PartID', order: 'asc' })
    const [open, setOpen] = useState(false);
    const [pdfOpen, setPdfOpen] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [checkPointTemplates, setCheckPointTemplates] = useState([]);
    const [company, setCompany] = useState({})
    const [loader, setLoader] = useState(false)
    const [methods, setMethods] = useState([])
    const [arrayLenght, setArrayLenght] = useState(0);
    const [allPartsCache, setAllPartsCache] = useState([]);
    const [itemNumber, setAllItemNumber] = useState([]);
    const [operations, setAllOperations] = useState([]);
    const [selectedTemplates, setSelectedTemplate] = useState({ Columns: [] })
    const [pdfData, setPdfData] = useState([])
    const [CurrentPage, setCurrentPage] = useState(1);
    const [TotalPage, setTotalPage] = useState(5);
    const [PageSize, setPageSize] = useState(25);

    const customerRef = useRef(null);
    // const filteredOptions = clients.filter((o) => !selectedItems.find(b => o.label == b));

    useEffect(() => {
        Heading('SPC Report')
        GetAllInspetcionTypes();
        getAllPart();
        getAllMethods();
        getCompanyDetail()
        getAllTemplate()

        // handleGetData("Default")
    }, [])


    const rules = [
        { value: "None", label: "None", desciption: "None" },
        { value: "Rule1", label: "Rule 1: Check upper and lower limit", desciption: "Check upper and lower limit" },
        { value: "Rule2", label: "Rule 2: Detect nine consecutive points on the same side of the mean", desciption: "Check upper and lower limit" },
        { value: "Rule3", label: "Rule 3: Detect six consecutive points moving upward or downward", desciption: "Check upper and lower limit" },
        { value: "Rule4", label: "Rule 4: Fourteen consecutive points either increasing or decreasing", desciption: "Check upper and lower limit" },
        { value: "Rule5", label: "Rule 5: Detect 2 out of 3 consecutive points falls in zone A", desciption: "Check upper and lower limit" },
        { value: "Rule6", label: "Rule 6: Four out of five consecutive points in Zone B or beyond", desciption: "Check upper and lower limit" },
        { value: "Rule7", label: "Rule 7: Fifteen consecutive points in Zone C", desciption: "Check upper and lower limit" },
        { value: "Rule8", label: "Rule 8: 8 consecutive points are in both directions but none in within zone C", desciption: "Check upper and lower limit" }
    ]

    const getCompanyDetail = () => {
        axios.get(api.api + 'company/' + auth.getCurrentUser().company)
            .then((result) => {
                setCompany(result.data)
            })
            .catch((err) => {
                console.error(err);
            });
    }





    const handleOnChange = (name, value) => {
        const obj = { ...inputData }
        if (name == "Parameter") {
            obj[name] = value.value;
            obj[name + "Field"] = value.name;
            setInputData(obj);
        } else {
            obj[name] = value;
            setInputData(obj);
        }

        if (name == "InspectionType") {

            if (
                obj.ItemName?.length > 0 ||
                obj.Operation?.length > 0 ||
                obj.ItemNumber?.length > 0
            ) {
                obj.ItemName = [];
                obj.ItemNumber = [];
                obj.Operation = [];
                setInputData({ ...obj });
                setAllOperations([])
                setAllItemNumber([])
                setAllParts([])

            }

            const numbers = allPartsCache
                .filter(one => one.Inspection.some(x => (value.includes(x.InspectionName)) && x.Enable) || value.includes("All"))
                .map(one => ({ label: one.ItemName, value: one.ItemName }));

            setAllParts(numbers);

        }
        if (name == "ItemName") {
            if (obj.ItemNumber?.length > 0) {
                obj.ItemNumber = [];
                obj.Operation = [];
                console.log(obj, "Clearing ItemNumber and Operation for ItemName");
                setInputData({ ...obj });
            }

            const numbers = allPartsCache.map((one) => {
                if (value.includes(one.ItemName) || value.includes("All")) {
                    return { label: one.ItemNumber, value: one.ItemNumber }
                }
            })
            setAllItemNumber(numbers.filter(x => x))

        }
        if (name == "ItemNumber") {
            if (obj.Operation?.length > 0) {
                obj.Operation = [];
                console.log(obj, "Clearing Operation for ItemNumber");
                setInputData({ ...obj });
            }
            const operations = allPartsCache.map((one) => {
                if ((inputData.ItemName && inputData.ItemName.includes(one.ItemName) || inputData.ItemName.includes("All")) && (value.includes(one.ItemNumber) || value.includes("All"))) {
                    return { label: one.Operation, value: one.Operation }
                }
            })
            setAllOperations(operations.filter(x => x));
        }
    }



    const getAllMethods = () => {
        axios.get(api.api + "method")
            .then((result) => {
                setMethods(result.data)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }


    const getAllInspection = () => {
        axios.get(api.api + "inspectionType")
            .then((result) => {
                const all = result.data.map((one) => { return { label: one.InspectionType, value: one.InspectionType } })
                setAllTypes(all)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }

    const getAllPart = () => {
        axios.get(api.api + "item")
            .then((result) => {
                setAllPartsCache(result.data)

                const all = result.data.map((one) => { return { label: one.ItemName, value: one.ItemName } })

                // setAllParts(all)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }


    useEffect(() => {
        validateAndApply()

    }, [CurrentPage, PageSize]);

    const validateAndApply = () => {
        if (!inputData.InspectionType || (inputData.InspectionType.length == 0)) {
            return
        }
        if (!inputData.ItemName || (inputData.ItemName.length == 0)) {
            return
        }
        if (!inputData.ItemNumber || (inputData.ItemNumber.length == 0)) {
            return
        }
        if (!inputData.Operation || (inputData.Operation.length == 0)) {
            return
        }
        if (!inputData.Rules || (inputData.Rules.length == 0)) {
            return
        }
        handleGetData("Param")
    }

    const handleGetData = async (type) => {
        // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
        const obj = { ...inputData };
        const parameter = [];
        const all = _.uniqBy(getCharacterstics().returnArr, "label")
        all.forEach(x => {
            if (obj.Parameters==x.value) {
                parameter.push({
                    Parameter: x.value.toString(),
                    ParameterField: x.name.toString(),
                    DimensionField: x.DimensionField ? x.DimensionField.toString() : null,
                    Min: x.Min ? x.Min : 0,
                    Max: x.Max ? x.Max : 0,
                    Standard: x.Standard ? x.Standard : 0,
                })
            }
        })
        obj.Parameters = parameter
        setLoader(true)
        axios.put(api.api + 'SPC', obj)
            .then((result) => {
                setLoader(false)

                // if (type == "Default") {
                //     const obj = { ...inputData, InspectionType: ["All"], ItemName: ["All"], ItemNumber: ["All"], Operation: ["All"] };
                //     setInputData(obj);
                // }
                // setTotalPage(result.data.totalDocument);
                result.data.forEach((one, idx) => {
                    one.Min = parameter[idx].Min;
                    one.Max = parameter[idx].Max;
                    one.Standard = parameter[idx].Standard;
                })
                setQualityData(result.data);
                //setArrayLenght(result.data.length > 0 ? result.data[0].Reports.length : 0)
            })

            .catch((err) => {
                setLoader(false)
                console.log(err);
            })
    }

    async function getBase64FromImageUrl(url) {
        try {
            // Fetch the image data from the URL
            const response = await fetch(url);
            const blob = await response.blob();

            // Create a FileReader to convert the Blob to base64
            const reader = new FileReader();

            return new Promise((resolve, reject) => {
                reader.onloadend = function () {
                    // Extract base64 string from the data URL
                    const base64String = reader.result.split(',')[1];
                    resolve(base64String);
                };

                reader.onerror = function (error) {
                    reject(error);
                };

                // Read the Blob as a data URL
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('Error fetching or converting image:', error);
            throw error;
        }
    }



    const handleGetPdfData = async (query) => {
        // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
        setLoader(true)
        axios.put(api.api + 'ViewReport', query)
            .then((result) => {
                setPdfData(result.data);
                setLoader(false)
            })
            .catch((err) => {
                setLoader(false)
                console.log(err);
            })
    }

    const reportTypes = ["Retrospective Inspection",
        "Setup Approval Inspection",
        "Process/Product Patrol Inspection",
        "Poka - Yoke Sheet",
        "IFM - Product - Msr",
        "IFM - Process - Fbd",
        "IFM_Product_FBD",
        "Last Part Inspection"

    ]

    const getGroupByField = (obj) => {
        if (obj && obj.InspectionType) {
            const inspectionType = allTypeCache.find(x => x.InspectionType == obj.InspectionType)
            if (inspectionType) {
                let fields = inspectionType.CustomFields.filter(x => x.UsedForGroupBy)
                if (fields.length > 0) {
                    fields = fields.map(x => x.FieldName)
                    return fields.map(x => {
                        const field = obj.customFields.find(y => y.FieldName == x)
                        if (field && field.FieldName == "Date_Shift") {
                            field.Value = moment(field.Value).format('DD-MM-YYYY')
                            return field
                        }
                        return field
                    }).map(x => x && x.Value).filter(x => x).join(" | ")
                }
            }
        }
        return '-'
    }
    const columns1 = [
        { path: "SerialNumber", label: "Serial Number" },
        { path: "DateTime", label: "Date", content: (obj) => (<>{moment(obj.DateTime).format('DD-MM-YY')}</>) },
        { path: "DateTime", label: "Time", content: (obj) => (<>{moment(obj.DateTime).format('hh:mm a')}</>) },
        { path: "Item", label: "Item Name" },
        { path: "ItemNumber", label: "Item Number" },
        { path: "Operation", label: "Operation" },
        { path: "InspectionType", label: "Inspection Type" },
        {
            path: "key", label: "Report For", content: (obj) => <>{getGroupByField(obj)}</>
        },
        { path: "QtyToInspect", label: "Qty To Inspect" },
        { path: "QtyInspected", label: "Qty Inspected" },
        { path: "OkParts", label: "Ok Parts" },
        { key: "Reject Parts", label: "Reject Parts", content: (obj) => (<>{obj.QtyToInspect - obj.OkParts}</>) },
        { path: "State", label: "Status" },
        {
            key: "InspectionData",
            label: <table class="table table-bordered mb-0 m-0 p-0">
                <thead>
                    <tr>
                        {[...Array(arrayLenght)].map((item, index) => (<>
                            <th colSpan={3}>{'Sample ' + (index + 1)}</th>
                        </>))}
                    </tr>
                </thead>
            </table>,
            content: (obj) => (
                <React.Fragment>
                    <table class="table table-bordered">
                        <thead>
                            {/* <tr>
                {[...Array(obj.InspectionData[0].InspectionData.length)].map((item,index) => (<>
                  <th  colSpan={3}>{'Sample '+(index+1) }</th>
                  </> ))}
                   </tr> */}
                            <tr>
                                {/* { obj.InspectionData.length > 0 && [...Array(obj.InspectionData[0].InspectionData.length)].map((item,index) => (<>
                 <th  >Observation</th ><th  >Result</th ><th  >Remarks</th >
                  </> ))} */}
                            </tr>
                        </thead>
                        {/* <tbody >
                {obj.InspectionData.map((item,index) => (<tr>
                  {item.InspectionData.map((one,idx)=><> <td>{one.ObservedValue}</td><td style={{backgroundColor:`${one.Result==='NA' ?'#FFA500':(one.Result==='NG') ?'red':'#28A745'}`}}>{one.Result}</td><td>{one.Remarks}</td></>)}
                  </tr> ))}
              </tbody> */}
                    </table>
                </React.Fragment>
            ),
        },
        {
            key: "view",
            label: "View Report",
            content: (obj) => (
                <React.Fragment>
                    <button className='btn btn-secondary' onClick={() => {
                        const part = allPartsCache.find((part) => part.ItemName == obj.Item && part.ItemNumber == obj.ItemNumber && part.Operation == obj.Operation)
                        if (part) {
                            handleGetPdfData({ _id: obj._id, InspectionType: obj.InspectionType, ItemName: obj.Item, ItemNumber: obj.ItemNumber, Operation: obj.Operation, From: obj.DateTime, Till: obj.DateTime })
                            const checkSheet = part.Inspection.find(x => x.InspectionName == obj.InspectionType)
                            const template = checkPointTemplates.find(x => checkSheet.checkSheetTitle.length > 0 && checkSheet.checkSheetTitle.some(c => c.TemplateName == x.Name))
                            //template.Columns = template.Columns.filter(x => x.EnableForDataEntry)
                            setSelectedTemplate(template)
                        }
                        setReportData(obj);
                        setOpen(true)

                    }}>
                        <FontAwesomeIcon icon={faFile} />
                    </button>
                </React.Fragment>
            ),
        },
        {
            key: "PDF View",
            label: "View PDF",
            content: (obj) => (
                <React.Fragment>
                    {
                        reportTypes.filter(item => item == obj.InspectionType).length > 0 ? <button className='btn btn-secondary' onClick={() => {
                            const part = allPartsCache.find((part) => part.ItemName == obj.Item && part.ItemNumber == obj.ItemNumber && part.Operation == obj.Operation)
                            if (part) {
                                const checkSheet = part.Inspection.find(x => x.InspectionName == obj.InspectionType)
                                const template = checkPointTemplates.find(x => checkSheet.checkSheetTitle && (checkSheet.checkSheetTitle.includes(z => z.TemplateName == x.Name)))
                                // template.Columns = template.Columns.filter(x => x.EnableForDataEntry)
                                setSelectedTemplate(template)
                                const shift = obj.customFields.find(x => x && x.FieldName == "Shift")
                                const batchCode = obj.customFields.find(x => x && x.FieldName == "Batch Code")
                                const machine = obj.customFields.find(x => x && x.FieldName == "Machine")
                                if (obj.InspectionType == "Poka - Yoke Sheet") {
                                    const reportDate = moment(obj.DateTime);

                                    // Start of the month
                                    const startOfMonth = reportDate
                                        .startOf("month")
                                        .format("YYYY-MM-DD");

                                    // End of the month
                                    const endOfMonth = reportDate
                                        .endOf("month")
                                        .format("YYYY-MM-DD");
                                    // Output: 2024-12-31

                                    handleGetPdfData({
                                        _id: obj._id,
                                        InspectionType: obj.InspectionType,
                                        ItemName: obj.Item,
                                        ItemNumber: obj.ItemNumber,
                                        Operation: obj.Operation,
                                        From: startOfMonth,
                                        Till: endOfMonth,
                                        Shift: shift ? shift.Value : "",
                                    });
                                } else {
                                    handleGetPdfData({ _id: obj._id, InspectionType: obj.InspectionType, ItemName: obj.Item, ItemNumber: obj.ItemNumber, Operation: obj.Operation, From: obj.DateTime, Till: obj.DateTime, Machine: machine, BatchCode: batchCode, Shift: shift ? shift.Value : "" })
                                }
                            }
                            setReportData(obj);
                            setPdfOpen(true)
                        }}>
                            <FontAwesomeIcon icon={faFilePdf} />
                        </button>
                            : <Tooltip text="Report Unavailable">
                                <button className='btn btn-secondary' disabled={true}>
                                    <FontAwesomeIcon icon={faFilePdf} />

                                </button>
                            </Tooltip>}


                </React.Fragment>
            ),
        },

    ];



    const GetAllInspetcionTypes = () => {
        axios.get(api.api + 'customInspection')
            .then((result) => {
                const reports = [...reportType]
                result.data.forEach((one) => {
                    const obj = { label: one.InspectionType, value: one.InspectionType, name: one.InspectionType }
                    reports.push(obj)
                })
                setAllTypeCache(result.data)
                setAllTypes(reports)
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const getAllTemplate = () => {
        axios.get(api.api + "checkPointConfig")
            .then((result) => {
                setCheckPointTemplates(result.data)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }

    const reports = {
        "Retrospective Inspection": <ProcessProductPatrolInspection item={allPartsCache.find(x => x.ItemName == inputData.ItemName)} company={company} data={reportData} pdfData={pdfData} test={qualityData} />,
        "Setup Approval Inspection": <ProcessProductPatrolInspection item={allPartsCache.find(x => x.ItemName == inputData.ItemName)} company={company} data={reportData} pdfData={pdfData} />,
        "Process/Product Patrol Inspection": <ProcessProductPatrolInspection item={allPartsCache.find(x => x.ItemName == inputData.ItemName)} company={company} data={reportData} pdfData={pdfData} />,
        "Last Part Inspection": <ProcessProductPatrolInspection item={allPartsCache.find(x => x.ItemName == inputData.ItemName)} company={company} data={reportData} pdfData={pdfData} />,
        "Poka - Yoke Sheet": <PokaYokeSheet company={company} obj={reportData} data={pdfData} />,
        "IFM - Product - Msr": <DailyInitialFlowManagement company={company} data={reportData} pdfData={pdfData} test={qualityData} />,
        "IFM - Process - Fbd": <DailyInitialFlowManagement_PROCESS company={company} data={reportData} test={qualityData} />,
        "IFM_Product_FBD": <DailyInitialFlowManagement company={company} data={reportData} pdfData={pdfData} test={qualityData} />,

    }

    const getCharacterstics = () => {
        let returnArr = [];
        let message = "";
        const item = allPartsCache.find(x => x.ItemName == inputData.ItemName && x.ItemNumber == inputData.ItemNumber && x.Operation == inputData.Operation);
        if (item) {
            const selectedInpection = item.Inspection.find(x => x.InspectionName == inputData.InspectionType);
            if (selectedInpection) {
                selectedInpection.checkSheetTitle.forEach((sheet) => {
                    if (sheet) {
                        const templateName = checkPointTemplates.find(x => sheet && x.Name == sheet.TemplateName);
                        if (templateName) {
                            //const column = templateName.Columns.find(x => x.Primary);
                            const column = templateName.Columns.find(x => x.Primary);
                            const plusCol = templateName.Columns.find(x => x.DataType == "Dimension+Tolerance");
                            const minusCol = templateName.Columns.find(x => x.DataType == "Dimension-Tolerance");
                            const standardCol = templateName.Columns.find(x => x.DataType == "StandardDimension");

                            const StandardDim = templateName.Columns.find(x => x.DataType == "UserInputDecision");
                            if (column && sheet.checkpoints) {
                                sheet.checkpoints.forEach(check => {
                                    if (check.StandardType == "Dimension") {
                                        const max = plusCol && standardCol ? parseFloat(check[plusCol.DbFieldName]) + parseFloat(check[standardCol.DbFieldName]) : 0
                                        const min = minusCol && standardCol ? parseFloat(check[standardCol.DbFieldName]) - parseFloat(check[minusCol.DbFieldName]) : 0
                                        returnArr.push({ Standard: parseFloat(check[standardCol.DbFieldName]), Max: max, Min: min, DimensionField: StandardDim.DbFieldName, label: check[column.DbFieldName], value: check[column.DbFieldName], name: column.DbFieldName })
                                    }
                                })
                            } else {
                                message = "No primary column is defined in the template. Please update the checkpoint configuration and select a primary column."
                            }
                        }
                    }
                });
            }
        }
        return { returnArr, message };
    }

    const getErrorMessage = () => {
        const { InspectionType = [], ItemName=[], ItemNumber=[], Operation=[] } = inputData;
        const { message, returnArr } = getCharacterstics();

        if (InspectionType.length > 0 && ItemName.length > 0 && ItemNumber.length > 0 && Operation.length > 0) {
            if (message) {
                return message;
            }
            if (!message && returnArr.length === 0) {
                return "No dimension checkpoint found for the selected inputs";
            }
        }

        return null; // nothing to show
    };

    return (
        <React.Fragment>
            {loader ? <Loading labelShow={true} label={"Loading..."} /> : ''}
            {/* <div className='text-center' >
                <p >QMS Report</p>
            </div> */}

            {/* <ToastContainer /> */}

            <div className="row">
                <div className="col-sm-2">
                    <div className="form-group">
                        <label className='small'>From</label>
                        <input value={moment(inputData.From).format('YYYY-MM-DD')} className='form-control form-control-sm' onChange={(e) => handleOnChange('From', e.currentTarget.value)} type='date' />

                    </div>
                </div>
                <div className="col-sm-2">
                    <div className="form-group">
                        <label className='small'>Till</label>
                        <input value={moment(inputData.Till).format('YYYY-MM-DD')} className='form-control form-control-sm' onChange={(e) => handleOnChange('Till', e.currentTarget.value)} type='date' />

                    </div>
                </div>
                <div className='col-sm-2'>
                    <label className='small text-center'>Inspection Type</label>
                    <Select
                        showSearch
                        maxTagCount={"responsive"}
                        //mode="multiple"
                        placeholder="Select Inspection Type"
                        value={inputData.InspectionType}
                        onChange={(values) => {
                            if (values.includes('All')) {
                                if (inputData.InspectionType && (inputData.InspectionType.length === types.length)) {
                                    handleOnChange('InspectionType', []);
                                } else {
                                    handleOnChange('InspectionType', ["All"]);
                                }
                            } else {
                                // Update selected values normally
                                handleOnChange('InspectionType', values);
                            }
                        }}
                        style={{ width: '100%' }}
                        options={[
                            //  { label: 'All', value: 'All' },
                            ...types
                        ]}
                    />

                </div>
                <div className='col-sm-2'>
                    <label className='small text-center'>Item</label>
                    <Select
                        showSearch
                        maxTagCount={"responsive"}
                        // mode="multiple"
                        placeholder="Select Item"
                        value={inputData.ItemName}
                        onChange={(values) => {
                            if (values.includes('All')) {
                                if (inputData.ItemName && (inputData.ItemName.length === parts.length)) {
                                    // Deselect all if "Select All" was deselected
                                    handleOnChange('ItemName', []);
                                } else {
                                    // Select all
                                    handleOnChange('ItemName', ["All"]);
                                }
                            } else {
                                // Update selected values normally
                                handleOnChange('ItemName', values);
                            }
                        }}
                        style={{ width: '100%' }}
                        options={parts.length == 0 ? [] : [
                            // { label: 'All', value: 'All' },
                            ..._.uniqBy(parts, "value")
                        ]}
                    />
                </div>
                <div className='col-sm-2'>
                    <label className='small text-center'>Item Number</label>
                    <Select
                        showSearch
                        maxTagCount={"responsive"}
                        // mode="multiple"
                        placeholder="Select Item"
                        value={inputData.ItemNumber}
                        onChange={(values) => {
                            if (values.includes('All')) {
                                if (inputData.ItemNumber && (inputData.ItemNumber.length === itemNumber.length)) {
                                    // Deselect all if "Select All" was deselected
                                    handleOnChange('ItemNumber', []);
                                } else {
                                    // Select all
                                    handleOnChange('ItemNumber', ["All"]);
                                }
                            } else {
                                // Update selected values normally
                                handleOnChange('ItemNumber', values);
                            }
                        }}
                        style={{ width: '100%' }}
                        options={itemNumber.length == 0 ? [] : [
                            // { label: 'All', value: 'All' },
                            ..._.uniqBy(itemNumber, "value")
                        ]}
                    />
                </div>
                <div className='col-sm-2'>
                    <label className='small text-center'>Operation</label>
                    <Select
                        showSearch
                        maxTagCount={"responsive"}
                        //mode="multiple"
                        placeholder="Select Operation"
                        value={inputData.Operation}
                        onChange={(values) => {
                            if (values.includes('All')) {
                                if (inputData.Operation && (inputData.Operation.length === operations.length)) {
                                    // Deselect all if "Select All" was deselected
                                    handleOnChange('Operation', []);
                                } else {
                                    // Select all
                                    handleOnChange('Operation', ["All"]);
                                }
                            } else {
                                // Update selected values normally
                                handleOnChange('Operation', values);
                            }
                        }}
                        style={{ width: '100%' }}
                        options={operations.length == 0 ? [] : [
                            //  { label: 'All', value: 'All' },
                            ..._.uniqBy(operations, "value")
                        ]}
                    />
                </div>
                <div className='col-sm-4'>
                    <label className='small text-center'>Characterstics</label>
                    <Select
                        showSearch
                        // mode="multiple"
                        maxTagCount="responsive"
                        placeholder="Select Parameter"
                        value={inputData.Parameters || []}
                        onChange={(values) => handleOnChange("Parameters", values)}
                        style={{ width: "100%" }}
                    >
                        {_.uniqBy(getCharacterstics().returnArr, "label").map((option) => (
                            <Select.Option key={option.value} value={option.value} label={option.label}>
                                <Checkbox
                                    checked={inputData.Parameters==option.value}
                                    style={{ marginRight: 8 }}
                                />
                                {option.label}
                            </Select.Option>
                        ))}
                    </Select>
                    {getErrorMessage() && <span className='text-danger small'>{getErrorMessage()}</span>}
                </div>
                <div className='col-sm-4'>
                    <label className='small text-center'>Rules</label>
                    <Select
                        showSearch
                        mode="multiple"
                        maxTagCount="responsive"
                        placeholder="Select Rule"
                        value={inputData.Rules || []}
                        onChange={(values) => {
                            if (values.includes("None") && values.length > 1) {
                                values = ["None"]
                            }
                            handleOnChange("Rules", values)
                        }}
                        style={{ width: "100%" }}
                        optionLabelProp="label"
                    >
                        {rules.map((rule) => (
                            <Select.Option key={rule.value} value={rule.value} label={rule.label}>
                                <Checkbox
                                    disabled={rule.value !== "None" && inputData.Rules && inputData.Rules.length > 0 && inputData.Rules.some(x => x == "None")}
                                    checked={inputData.Rules?.includes(rule.value)}
                                    style={{ marginRight: 8 }}
                                />
                                {rule.label}
                            </Select.Option>
                        ))}
                    </Select>
                </div>

                <div className="col-sm-1">
                    <button className='btn btn-primary btn-sm mt-4' onClick={() => {
                        if (!inputData.InspectionType || (inputData.InspectionType.length == 0)) {
                            swal('Please select all inputs', { dangerMode: true });
                            return
                        }
                        else if (!inputData.ItemName || (inputData.ItemName.length == 0)) {
                            swal('Please select all inputs', { dangerMode: true });
                            return
                        }
                        else if (!inputData.ItemNumber || (inputData.ItemNumber.length == 0)) {
                            swal('Please select all inputs', { dangerMode: true });
                            return
                        }
                        else if (!inputData.Operation || (inputData.Operation.length == 0)) {
                            swal('Please select all inputs', { dangerMode: true });
                            return
                        }
                        handleGetData("Param")
                    }}>Apply</button>
                </div>

            </div>
            <div>
                {qualityData.map((data) => {
                    return <div className='mt-2' style={{ border: 'solid 1px gray' }}>
                        <SPCLineChart data={data} IsSPC={!inputData.Rules.includes("None")} />
                        {inputData.Rules && !inputData.Rules.includes("None") && data.Error && data.Error.length > 0 && <table style={{ width: '50%', marginLeft: '20%', marginTop: '10px' }} className="table table-sm table-striped table-bordered">
                            <thead>
                                <th>Rule</th>
                                {/* <th>Desciption</th> */}
                                <th>Result</th>

                            </thead>
                            <tbody>
                                {data.Error.map((one) => {
                                    return <tr>
                                        <td>{one}</td>
                                        {/* <td>{rules.find(x => x.value == one.Rule) ? rules.find(x => x.value == one.Rule).label : "-"}</td> */}
                                        <td>Failed</td>
                                    </tr>
                                })}
                            </tbody>
                        </table>}
                    </div>
                })}

            </div>
        </React.Fragment>
    );
}
export default SPCReport;